module.exports = __webpack_public_path__ + "static/usecase_phone2-df0af1e28c38f7cb8d0c37ff2973d0b8.png";